// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.starfield-scroll[data-v-2b6339ec] {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: 40px;
  padding-right: 40px;
}
@media (max-width: 768px) {
.starfield-scroll[data-v-2b6339ec] {
    padding-left: 8px;
    padding-right: 8px;
}
}
.starfield-bare .starfield-scroll[data-v-2b6339ec] {
  padding-left: 0;
  padding-right: 0;
}
#Test-id[data-v-2b6339ec] {
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}
.starfield.debug[data-v-2b6339ec] {
  z-index: 2;
}
.starfield[data-v-2b6339ec] {
  height: 100%;
  left: 0;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 0;
}
.starfield canvas[data-v-2b6339ec] {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
h1[data-v-2b6339ec] {
  color: white;
  position: relative;
  text-align: center;
  font-family: "StarWars";
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/Starfield.vue","webpack://./Starfield.vue"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;ACDF;ADGA;AACE;IACE,iBAAA;IACA,kBAAA;ACAF;AACF;ADGA;EACE,eAAA;EACA,gBAAA;ACDF;ADIA;EACE,YAAA;EACA,WAAA;EAEA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;ACFF;ADKA;EACE,UAAA;ACFF;ADMA;EACE,YAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;ACHF;ADMA;EACE,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;ACHF;ADYA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;ACTF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.starfield-scroll {\n  height: 100vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-left: 40px;\n  padding-right: 40px;\n}\n@media (max-width: 768px) {\n  .starfield-scroll {\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n}\n\n.starfield-bare .starfield-scroll {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n#Test-id {\n  height: 100%;\n  width: 100%;\n\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.starfield.debug {\n  z-index: 2;\n}\n\n\n.starfield {\n  height: 100%;\n  left: 0;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 0;\n}\n\n.starfield canvas {\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n//@font-face {\n  //font-family: StarWars;\n  //src: url('@/fonts/Starjhol.ttf') format('truetype');\n  //font-weight: normal;\n//}\n\nh1 {\n  color: white;\n  position: relative;\n  text-align: center;\n  font-family: 'StarWars';\n}\n",".starfield-scroll {\n  height: 100vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-left: 40px;\n  padding-right: 40px;\n}\n\n@media (max-width: 768px) {\n  .starfield-scroll {\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n}\n.starfield-bare .starfield-scroll {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n#Test-id {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.starfield.debug {\n  z-index: 2;\n}\n\n.starfield {\n  height: 100%;\n  left: 0;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 0;\n}\n\n.starfield canvas {\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\nh1 {\n  color: white;\n  position: relative;\n  text-align: center;\n  font-family: \"StarWars\";\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
